/**
 * Utility functions for handling URLs and redirects
 */

/**
 * Cleans the current URL by removing any return_to parameters
 * that could cause redirect loops
 */
export const cleanReturnToParameters = () => {
  try {
    const currentUrl = new URL(window.location.href);
    
    // Check if there's a return_to parameter
    if (currentUrl.searchParams.has('return_to')) {
      // Remove it from the URL
      currentUrl.searchParams.delete('return_to');
      
      // Update the browser history without causing a page reload
      window.history.replaceState({}, '', currentUrl.toString());
      
      return true;
    }
    
    return false;
  } catch (error) {
    console.error('Error cleaning URL parameters:', error);
    return false;
  }
};

/**
 * Extracts and validates a return_to parameter from the URL
 * @returns The validated return_to URL or null if invalid
 */
export const extractValidReturnToUrl = (): string | null => {
  try {
    const currentUrl = new URL(window.location.href);
    const returnToParam = currentUrl.searchParams.get('return_to');
    
    if (!returnToParam) return null;
    
    // Try to parse it as a URL to validate
    const targetUrl = new URL(returnToParam);
    
    // Check if it's an app URL
    if (targetUrl.hostname.includes('app.youaux.com')) {
      return returnToParam;
    }
    
    return null;
  } catch (error) {
    console.error('Error extracting return_to URL:', error);
    return null;
  }
}; 